const TransactionActionTypes = {
  FETCH_TRANSACTION_REQUEST: 'FETCH_TRANSACTION_REQUEST',
  FETCH_TRANSACTION_SUCCESS: 'FETCH_TRANSACTION_SUCCESS',
  FETCH_TRANSACTION_FAILURE: 'FETCH_TRANSACTION_FAILURE',
  SEND_TO_ESIGNER_REQUEST: 'SEND_TO_ESIGNER_REQUEST',
  SEND_TO_ESIGNER_FINISH: 'SEND_TO_ESIGNER_FINISH',
  SEND_TO_ESIGNER_SUCCESS: 'SEND_TO_ESIGNER_SUCCESS',
  SEND_TO_ESIGNER_FAILURE: 'SEND_TO_ESIGNER_FAILURE',
  SEND_TO_CLOUD_SIGNER_REQUEST: 'SEND_TO_CLOUD_SIGNER_REQUEST',
  SEND_TO_CLOUD_SIGNER_SUCCESS: 'SEND_TO_CLOUD_SIGNER_SUCCESS',
  SEND_TO_CLOUD_SIGNER_FAILURE: 'SEND_TO_CLOUD_SIGNER_FAILURE',
  SEND_TO_EMBEDDING_API_REQUEST: 'SEND_TO_EMBEDDING_API_REQUEST',
  SEND_TO_EMBEDDING_API_SUCCESS: 'SEND_TO_EMBEDDING_API_RSUCCESS',
  SEND_TO_EMBEDDING_API_FAILURE: 'SEND_TO_EMBEDDING_API_FAILURE'
}

export default TransactionActionTypes